import React from "react";
import { SectionOne } from "../components/sectionOne";
import { SectionTwo } from "../components/sectionTwo";

export const Landing = () => {
  return (
    <div className="App">
      <SectionOne />
      <SectionTwo />
    </div>
  );
};
